export default "__VITE_ASSET__CLJvtvYg__"